export const AUTH_MESSAGES = {
  EMAIL_NOT_VERIFIED: 'Potwierdź swój adres e-mail przed zalogowaniem. Sprawdź swoją skrzynkę pocztową.',
  NO_B2B_PERMISSION: 'Brak uprawnień do panelu B2B',
  NO_ADMIN_PERMISSION: 'Brak uprawnień administratora',
  LOGIN_FAILED: 'Logowanie nie powiodło się',
  REGISTER_FAILED: 'Rejestracja nie powiodła się',
  LOGOUT_FAILED: 'Wylogowanie nie powiodło się',
  AUTH_CHECK_FAILED: 'Sprawdzanie autoryzacji nie powiodło się',
  ROLE_CONFIRMATION_SENT:
    'Wysłaliśmy link na Twój adres e-mail. Kliknij go, aby dodać dostęp firmowy do istniejącego konta, a następnie zaloguj się.',
  EMAIL_EXISTS_OTHER_METHOD:
    'Ten adres e-mail ma już konto założone inną metodą (np. przez Google). Zaloguj się tą metodą — a jeśli chcesz korzystać z hasła, ustaw je przez opcję „Nie pamiętam hasła”.',
} as const;

export const AUTH_ERROR_CODE = {
  ROLE_CONFIRMATION_SENT: 'ROLE_CONFIRMATION_SENT',
  EMAIL_EXISTS_OTHER_METHOD: 'EMAIL_EXISTS_OTHER_METHOD',
} as const;
